import { useEffect, useState } from "react";
import { extractDominantColors } from "@/utils/extract-dominant-colors";

/** Memoized dominant-color extraction for an art URL, for the premium card light-stripe layer. */
export const useDominantColors = (url: string, count = 3): string[] => {
  const [colors, setColors] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    extractDominantColors(url, count).then((result) => {
      if (!cancelled) setColors(result);
    });
    return () => {
      cancelled = true;
    };
  }, [url, count]);

  return colors;
};
